// extracted by mini-css-extract-plugin
module.exports = {"clickable":"_3x47a"};